import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import BootstrapVue3 from "bootstrap-vue-3";
import { createMetaManager } from 'vue-meta'
import VueProgressBar from "@aacassandra/vue3-progressbar";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "./styles/mainStyle.scss";
import "animate.css";
import i18n from './i18n'

const app = createApp(App);

axios.defaults.baseURL = "https://www.googleapis.com/youtube/v3/"

app.config.globalProperties.$http = axios

app.use(router);
app.use(store);
app.use(i18n);
app.use(BootstrapVue3);
app.use(createMetaManager());
app.use(VueProgressBar, {
  color: "#30591a",
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
});

// Pour Vue 3, il faut monter l'app ainsi :
app.mount("#app");
